import type { IconName } from '@camelot/components'
import type { TranslationKey } from '~/composables/translate/translations'
import { useImage } from '@vueuse/core'
import { translate } from '~/composables/translate/translations'
import { useOfferStore } from '~/stores/offer'
import { useVehiclesStore } from '~/stores/vehicles'

export function useBuildSeries(buildSeries?: string) {
  const bs: string | undefined = buildSeries
    ?? useOfferStore().selectedOffer?.buildSeries

  function buildSeriesTranslation(): string | undefined {
    if (bs === undefined)
      return undefined
    return translate(`pre_${bs.toUpperCase()}` as TranslationKey)
  }

  const configuration = useVehiclesStore().getVehicleCategoryData(bs)

  function engineTypeTranslation(): string {
    return configuration?.isElectric
      ? translate('category_card_engine_type_electric')
      : translate('category_card_engine_type_combustion')
  }

  function engineTypeIcon(): IconName {
    return configuration?.isElectric
      ? 'charge'
      : 'fuel'
  }

  function gearTypeTranslation(): string {
    return configuration?.isAutomatic
      ? translate('category_card_automatic')
      : translate('category_card_manual')
  }

  function gearTypeIcon(): IconName {
    return configuration?.isAutomatic ? 'automatic' : 'gear_shift'
  }

  function seatsTranslation(): string {
    const nbSeats = String(configuration?.seats || 5)
    return translate(
      'extra_cat_detail_seats',
      { '{seats}': nbSeats },
    )
  }

  function minimumAgeTranslation(): string {
    const minimumAge = String(configuration?.minimumAge || 18)
    return translate(
      'extra_cat_detail_minimum_age',
      { '{years}': minimumAge },
    )
  }

  const imageURL = ref<string>(`${useRuntimeConfig().public.carImageBaseURL + bs?.toLowerCase()}.png`)
  useImage(
    { src: imageURL.value },
    {
      onError: () => { imageURL.value = `${useRuntimeConfig().public.imageURL}/default-vehicle.png` },
    },
  )

  return {
    buildSeriesTranslation,
    engineTypeTranslation,
    engineTypeIcon,
    gearTypeTranslation,
    gearTypeIcon,
    seatsTranslation,
    minimumAgeTranslation,
    imageURL,
  }
}
